import { mapState, mapActions } from "vuex";
import conf from "@/config";

export default {
  data: () => ({
    quantity: 0,
  }),
  computed: {
    ...mapState("companyMenu", ["dayTo"]),
    isDisabledCard() {
      // (this.dayTo > this.dailyMenu.date && !this.params.checkTime)
      return this.dailyMenu.disabled || this.dayTo > this.dailyMenu.date;
    },
    mealImage() {
      if (this.meal.image) {
        const restaurant = this.$store.state.restaurant
          ? this.$store.state.restaurant
          : this.$store.state.company.restaurant;
        const restaurantId = this.meal.clone_id
          ? this.meal.image.restaurant_id
          : restaurant.id;
        return [
          conf.apiUrlBase,
          "gallery",
          restaurantId,
          "small",
          this.meal.image.name,
        ].join("/");
      }
      return "./media/img/no-image.webp";
    },
    isWorker() {
      return this.$store.state.user.orderRules?.isWorker || false;
    },
    user() {
      return this.$store.state.user.user;
    },
    orderPayload() {
      const payload = {
        user_id: this.$store.state.user.user.id,
        meal_id: this.meal.id,
        date: this.dailyMenu.date,
        type: this.dailyMenu.type,
        quantity_payed: this.meal.order?.quantity_payed || 0,
        shift: this.shift,
        location: { longitude: "", latitude: "" },
        order: this.meal.order,
      };
      if (this.isWorker) payload.app_type = 1;
      return payload;
    },
  },
  methods: {
    ...mapActions("companyMenu", ["orderAction"]),
    sendOrderMeal(params) {
      this.orderAction(params)
        .then((res) => {
          if (res) {
            this.$store.dispatch("snackbar/showSnackbar", {
              message: this.$t("order_updated_successfully"),
              color: "success",
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch("snackbar/showSnackbar", {
            message: err.response?.data?.message || "Došlo je do greške.",
            color: "error",
            timeout: 8000,
          });
        });
    },
    onCompanyChange(event) {
      this.sendOrderMeal({
        ...this.orderPayload,
        quantity: event,
      });
    },
    updateQuantity(amount) {
      if (amount < 0 && this.quantity <= 0) return;
      this.sendOrderMeal({
        ...this.orderPayload,
        quantity: (this.quantity || 0) + amount,
      });
    },
    onCompanyBtnClick() {
      this.sendOrderMeal({
        ...this.orderPayload,
        quantity: this.quantity > 0 ? 0 : 1,
      });
    },
  },
  watch: {
    "meal.order.quantity": {
      handler(newVal) {
        this.quantity = newVal || 0;
      },
      immediate: true,
    },
  },
};
